import { useMutation } from "react-query";
import createOrg from "../services/createOrg";

const useCreateOrg = () => {
  return useMutation(["create-org"], createOrg);
};

export default useCreateOrg;
